import { useLocation, useSearchParams } from '@remix-run/react';
import { useEffect, useState } from 'react';

import { LocalStorageKeys } from '~/interfaces/local_storage';

const useLayout = () => {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const [isInPostSignupFlow, setIsInPostSignupFlow] = useState(false);

  // Show Full Layout
  const isHomePage = pathname === '/';
  const isPostPage = pathname.startsWith('/p/');
  const isCustomPage = pathname.startsWith('/c/');
  const isTagPage = pathname.startsWith('/t/');
  const isLayoutShowing = isTagPage || isCustomPage || isHomePage || isPostPage;

  // Show No Layout
  const isLandingPage = pathname === '/landing_page';
  const isLoginPage = pathname === '/login' || pathname === '/login-otp';
  const isCreatePasswordPage = pathname === '/create_password';
  const isResetPasswordPage = pathname === '/reset_password';
  const isUpdatePasswordPage = pathname === '/update_password';
  const isPreviewingForm = pathname.startsWith('/forms') && searchParams.has('preview');
  const isSignupPage =
    pathname.startsWith('/subscribe') &&
    !pathname.includes('/manage') &&
    !pathname.includes('/billing') &&
    !pathname.includes('/preferences') &&
    !pathname.includes('/referrals');
  const isTestHomePage = pathname === '/test_home_page';
  const isRecommendationsPage = pathname === '/recommendations';
  const isPollsPage = pathname.startsWith('/polls');
  const isPostSignupPage = pathname === '/upgrade';
  const isNoLayoutPage =
    isLandingPage ||
    isLoginPage ||
    isCreatePasswordPage ||
    isResetPasswordPage ||
    isUpdatePasswordPage ||
    isSignupPage ||
    isPostSignupPage ||
    isRecommendationsPage ||
    isPollsPage ||
    isPreviewingForm ||
    isInPostSignupFlow ||
    isTestHomePage;

  // Show no Footer
  const isFormsPage = pathname.startsWith('/forms');
  const isUpgradePage = pathname === '/upgrade';
  const isManagePage = pathname.startsWith('/subscribe') && pathname.endsWith('/manage');
  const isBillingPage = pathname.startsWith('/subscribe') && pathname.endsWith('/billing');
  const isPreferencesPage = pathname.startsWith('/subscribe') && pathname.endsWith('/preferences');
  const isReferralsPage = pathname.startsWith('/subscribe') && pathname.endsWith('/referrals');
  const isPublicationsPage = pathname === '/publications' || pathname === '/publications/';
  const isNoFooterPage =
    isUpgradePage ||
    isManagePage ||
    isBillingPage ||
    isPreferencesPage ||
    isFormsPage ||
    isPublicationsPage ||
    isReferralsPage;

  useEffect(() => {
    try {
      const checkForRedirects = Boolean(localStorage?.getItem(LocalStorageKeys.SIGNUP_REDIRECTS));
      setIsInPostSignupFlow(checkForRedirects);
    } catch {
      setIsInPostSignupFlow(false);
    }
  }, [pathname]);

  if (isLayoutShowing) {
    return {
      isNavShowing: true,
      isFooterShowing: true,
    };
  }

  if (isNoLayoutPage) {
    return {
      isNavShowing: false,
      isFooterShowing: false,
    };
  }

  if (isNoFooterPage) {
    return {
      isNavShowing: true,
      isFooterShowing: false,
    };
  }

  return {
    isNavShowing: true,
    isFooterShowing: true,
  };
};

export default useLayout;
